import { format } from 'date-fns';
import { Typography } from '@components/Typography';
import { Checkbox } from '@components/Checkbox';
import { LabelPlain } from '@components/Label';
import {} from '@constants/integrations';
import { useTranslation } from '@hooks';
import { formatAssignedEntities } from '@helpers/formatEntitiesToString';
import { InfoWrapper, UnsubscribeWrapper } from './styles';

const overflowStyle = {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '100%',
};

const Info = ({ contact, isSmallScreen, resizable, companies }) => {
    const { t } = useTranslation();

    return (
        <>
            <InfoWrapper>
                <Typography variant="caption" color="textSecondary" sx={{ marginBottom: '6px' }}>
                    {t('common.firstName')}
                </Typography>
                <Typography variant={isSmallScreen && resizable ? 'caption' : 'body2'}>
                    {contact?.firstName || '--'}
                </Typography>
            </InfoWrapper>
            <InfoWrapper>
                <Typography variant="caption" color="textSecondary" sx={{ marginBottom: '6px' }}>
                    {t('common.lastName')}
                </Typography>
                <Typography variant={isSmallScreen && resizable ? 'caption' : 'body2'}>
                    {contact?.lastName || '--'}
                </Typography>
            </InfoWrapper>
            <InfoWrapper>
                <Typography variant="caption" color="textSecondary" sx={{ marginBottom: '6px' }}>
                    {t('common.phoneNumber')}
                </Typography>
                <Typography variant={isSmallScreen && resizable ? 'caption' : 'body2'}>
                    {contact?.phoneNumber || '--'}
                </Typography>
            </InfoWrapper>
            <InfoWrapper>
                <Typography variant="caption" color="textSecondary" sx={{ marginBottom: '6px' }}>
                    {t('common.emailAddress')}
                </Typography>
                <Typography variant={isSmallScreen && resizable ? 'caption' : 'body2'} sx={overflowStyle}>
                    {contact?.email || '--'}
                </Typography>
            </InfoWrapper>
            <InfoWrapper>
                <Typography variant="caption" color="textSecondary" sx={{ marginBottom: '6px', ...overflowStyle }}>
                    {t('ContactsPage.facebookProfile')}
                </Typography>
                <Typography variant={isSmallScreen && resizable ? 'caption' : 'body2'} sx={overflowStyle}>
                    {contact?.facebookProfile ? (
                        <span style={{ color: 'rgba(0, 0, 0, 0.6)' }}>facebook.com/</span>
                    ) : (
                        '--'
                    )}
                    {contact?.facebookProfile}
                </Typography>
            </InfoWrapper>
            <InfoWrapper>
                <Typography variant="caption" color="textSecondary" sx={{ marginBottom: '6px' }}>
                    {t('ContactsPage.instagramProfile')}
                </Typography>
                <Typography variant={isSmallScreen && resizable ? 'caption' : 'body2'} sx={overflowStyle}>
                    {contact?.instagramProfile ? (
                        <span style={{ color: 'rgba(0, 0, 0, 0.6)' }}>instagram.com/</span>
                    ) : (
                        '--'
                    )}
                    {contact?.instagramProfile}
                </Typography>
            </InfoWrapper>
            <InfoWrapper>
                <Typography variant="caption" color="textSecondary" sx={{ marginBottom: '6px' }}>
                    {t('common.locations')}
                </Typography>
                <Typography variant={isSmallScreen && resizable ? 'caption' : 'body2'}>
                    {formatAssignedEntities(companies, contact?.companies, {
                        idKey: 'companyId',
                        labelKey: 'internalName',
                    })}
                </Typography>
            </InfoWrapper>
            {contact?.createdOn ? (
                <InfoWrapper>
                    <Typography variant="caption" color="textSecondary" sx={{ marginBottom: '6px' }}>
                        {t('ContactsPage.createdOn')}
                    </Typography>
                    <Typography variant={isSmallScreen && resizable ? 'caption' : 'body2'}>
                        {format(new Date(contact?.createdOn), 'dd MMM yyyy')}
                    </Typography>
                </InfoWrapper>
            ) : null}
            <InfoWrapper>
                <Typography variant="caption" color="textSecondary" sx={{ marginBottom: '6px' }}>
                    {t('common.labels')}
                </Typography>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
                    {contact?.labels?.length
                        ? contact?.labels?.map(label => (
                              <LabelPlain key={label.id} type={label.name} variant="caption">
                                  {label.name}
                              </LabelPlain>
                          ))
                        : '--'}
                </div>
            </InfoWrapper>
            <UnsubscribeWrapper>
                <Checkbox checked={!!contact?.unsubscribed} disabled />
                <Typography variant="caption">{t('ContactsPage.unsubscribed')}</Typography>
            </UnsubscribeWrapper>
        </>
    );
};

export default Info;
